import { AssistantItems } from '@repo/shared/dtos/assistant'
import { Button } from '@repo/ui/button'
import { useT } from '@repo/ui/hooks'
import { useState } from 'react'

import { useBeneficiaryListAsSheet } from '@/components/beneficiary/list/sheet/hook'
import { downloadCSV } from '@/components/helpers'
import { MarkdownWrapper } from '@/components/MarkdownWrapper'

import { AddInsightWidgetButton } from './AddWidgetButton'

export function BeneficiaryInsightsCta({
  item,
}: {
  item: AssistantItems['beneficiaryInsightsCta']
}) {
  const { t } = useT({ keyPrefix: 'admin.insights.chat' })
  const { setOpen } = useBeneficiaryListAsSheet()
  const [openExplanations, setOpenExplanations] = useState(false)

  const handleOpenFilters = () => {
    if (!item.filters) return
    setOpen(true, { filterTemplate: { name: '', filters: item.filters } })
  }

  const handleOpenExplanations = () => {
    if (!item.explanations || item.explanations.length === 0) return
    setOpenExplanations(!openExplanations)
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-row gap-2">
        <Button variant="outline" size="sm" onClick={handleOpenExplanations}>
          {t('openExplanations', { cfl: false })}
        </Button>
        {item.filters && item.filters.length > 0 && (
          <Button variant="outline" size="sm" onClick={handleOpenFilters}>
            {t('openFilters', { cfl: true })}
          </Button>
        )}
        {item.csv !== undefined && (
          <Button
            variant="outline"
            size="sm"
            onClick={() => downloadCSV('insights.csv', item.csv!)}
          >
            {t('downloadCSV', { cfl: true })}
          </Button>
        )}
        {item.recommendedDisplay && <AddInsightWidgetButton item={item} />}
      </div>
      {openExplanations && item.explanations && (
        <div className="flex flex-col gap-2">
          <pre className="text-xs text-wrap">
            <MarkdownWrapper content={item.explanations} />
          </pre>
        </div>
      )}
    </div>
  )
}
